export const domainConfig = {
  id: "restaurant",
  name: "Nhà hàng & F&B",
  icon: "🍽️",
  description: "Tạo nội dung marketing cho ngành nhà hàng và F&B",

  projectTypes: {
    "Nhà hàng cao cấp (Fine Dining)": 1,
    "Nhà hàng gia đình": 2,
    "Quán ăn bình dân": 3,
    "Fast Food / Quick Service": 4,
    "Café & Bakery": 5,
    "Bar & Pub": 6,
    "Food Truck": 7,
    "Nhà hàng buffet": 8,
    "Quán lẩu nướng": 9,
    "Quán ăn chay": 10,
    "Cửa hàng bánh kẹo": 11,
    "Dịch vụ catering": 12,
  },

  contentTypes: {
    "Giới thiệu món ăn mới": 1,
    "Quảng cáo chương trình khuyến mại": 2,
    "Chia sẻ công thức nấu ăn": 3,
    "Review từ khách hàng": 4,
    "Behind the scenes - Hậu trường": 5,
    "Giới thiệu đầu bếp": 6,
    "Câu chuyện nguồn gốc món ăn": 7,
    "Sự kiện đặc biệt": 8,
    "Tips chọn nguyên liệu": 9,
    "Văn hóa ẩm thực": 10,
    "Tuyển dụng nhân viên": 11,
    "Thông báo giờ mở cửa": 12,
  },

  defaults: {
    projectType: "Nhà hàng gia đình",
    contentType: "Giới thiệu món ăn mới",
    postLength: "Ngắn gọn",
    postStyles: ["Thân thiện"],
  },

  labels: {
    projectTypeLabel: "Loại hình kinh doanh",
    contentTypeLabel: "Loại nội dung",
    projectInfoLabel: "Thông tin nhà hàng",
    projectInfoPlaceholder:
      "Mô tả về nhà hàng, món ăn đặc trưng, không gian, phong cách phục vụ...\n- Tên nhà hàng/quán\n- Địa chỉ, vị trí\n- Món ăn đặc sản\n- Không gian, phong cách\n- Giá cả, chương trình khuyến mại...",
    targetCustomerLabel: "Khách hàng mục tiêu",
    targetCustomerPlaceholder:
      "VD: Gia đình có trẻ em, giới trẻ, doanh nhân, du khách...",
  },

  settings: {
    requiresLocation: true,
    requiresPrice: true,
    allowedImageTypes: ["food", "restaurant", "menu"],
  },
};
